
import XTable from 'vux/src/components/x-table/index.vue'

import { mapMutations } from "vuex";
export default {
name: "L_T4",
components: {
XTable
},
methods: {
...mapMutations(["hideLoad"])
},
created() {
this.hideLoad();
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/L_T4.vue